"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.Modal = void 0;
const React = require("react");
const react_1 = require("react");
const react_responsive_modal_1 = require("react-responsive-modal");
const Dialog_1 = require("../Dialog");
const dialogs_1 = require("../../../../types/dialogs");
const NavigationBar_1 = require("../NavigationBar");
const Icon_1 = require("../../atoms/Icon");
const standardSizes_1 = require("../../../../types/standardSizes");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Modal");
const ModalContext = React.createContext({ onClose: undefined });
// Wrapper for a third party library
const Modal = (_a) => {
    var { children, fullScreen, size, onClose, appMode = false, container = null, sticky = false, className } = _a, rest = __rest(_a, ["children", "fullScreen", "size", "onClose", "appMode", "container", "sticky", "className"]);
    return (React.createElement(react_responsive_modal_1.default, Object.assign({ center: true, container: container, classNames: {
            overlay: css("overlay", `-size-${size}`, {
                "-relative": !!container,
                "-appMode": appMode
            }),
            modal: css("modal", `-size-${size}`, {
                "-appMode": appMode,
                "-sticky": sticky,
                "-closeable": !!onClose,
                className
            }),
            closeButton: css("close", { "-appMode": appMode })
        }, onClose: onClose ? onClose : () => { }, showCloseIcon: !!onClose }, rest),
        React.createElement("div", { "data-test": "dialog", className: "nph" },
            React.createElement(ModalContext.Provider, { value: { onClose } },
                React.createElement(Dialog_1.Dialog, { size: dialogs_1.TDialogSizes.Full, className: css("dialog", { className }), sticky: sticky, closeable: !!onClose }, children)))));
};
exports.Modal = Modal;
const ModalHeader = (_a) => {
    var { children, navbar = true } = _a, // TODO: remove this
    props = __rest(_a, ["children", "navbar"]);
    const { onClose } = (0, react_1.useContext)(ModalContext);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css("-stateDefault") },
            React.createElement(Dialog_1.DialogHeader, Object.assign({}, props),
                children,
                React.createElement("div", { className: css("closeIcon", {
                        className: props.className ? `${props.className}_closeIcon` : ""
                    }) },
                    React.createElement(Icon_1.Icon, { onClick: onClose, size: standardSizes_1.TStandardSizes.ExtraSmall, name: "close" })))),
        navbar ? (React.createElement("div", { className: css("-stateApp") },
            React.createElement(NavigationBar_1.NavigationBar, { backClick: onClose, backLabel: "", noBackChevron: true, className: css("navigationBar") },
                children,
                React.createElement("div", { className: css("closeIcon"), onClick: onClose ? onClose : () => { } },
                    React.createElement(Icon_1.Icon, { size: standardSizes_1.TStandardSizes.ExtraSmall, name: "close" }))))) : null));
};
exports.ModalHeader = ModalHeader;
const ModalBody = props => (React.createElement(Dialog_1.DialogBody, Object.assign({}, props)));
exports.ModalBody = ModalBody;
const ModalFooter = props => (React.createElement("div", { className: css("footer", { className: props.className }) },
    React.createElement(Dialog_1.DialogFooter, Object.assign({}, props, { className: props.className ? `${props.className}_dialogFooter` : "" }))));
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=index.js.map